import * as yup from 'yup';

export interface IStepTypeFormInfo {
	service: '' | 'Letter' | 'Parcel';
	parcelCount: number;
}
export const stepTypeInitialValues: IStepTypeFormInfo = {
	service: '',
	parcelCount: 1,
};

export const StepTypeSchema = yup.object().shape({
	service: yup.string().required('step-type.service-required-text'),
	parcelCount: yup.number().when('service', {
		is: 'Parcel',
		then: yup.number().min(1, 'step-type.parcel-count-required-text'),
	}),
});
